module.exports = __webpack_public_path__ + "static/media/support.cd759fac.jpg";